import { useAuth, useLaunchDarklyStatus } from "@assetwatch/auth";
import { Alert, Container, FullPageLoading, Stack } from "@assetwatch/ui";
import type { ReactNode } from "react";
import {
  MlFrontendFeatureDisabledError,
  MlFrontendUnauthorizedError,
} from "../errors/errors";
import { assertCanAccessMlFrontend } from "../lib/access";
import { useFeatureFlags } from "./LaunchDarkly/useFeatureFlags";

export function AppFeatureGate({ children }: { children: ReactNode }) {
  const flags = useFeatureFlags();
  const hasLaunchDarklyClient = Boolean(
    import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID,
  );
  const { isReady } = useLaunchDarklyStatus();
  const { user } = useAuth();

  if (hasLaunchDarklyClient && !isReady) {
    return <FullPageLoading />;
  }

  try {
    assertCanAccessMlFrontend({ flags, user });
  } catch (error) {
    if (error instanceof MlFrontendFeatureDisabledError) {
      return (
        <Container size="sm">
          <Stack gap={16}>
            <Alert
              tone="informative"
              title="App currently unavailable"
              subtext="This app is not enabled for your account."
            />
          </Stack>
        </Container>
      );
    }

    if (error instanceof MlFrontendUnauthorizedError) {
      return (
        <Container size="sm">
          <Stack gap={16}>
            <Alert
              tone="negative"
              title="Access denied"
              subtext="Contact the ML team if you feel you've reached this message in error."
            />
          </Stack>
        </Container>
      );
    }

    throw error;
  }

  return <>{children}</>;
}
